import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const printedForm = {
  path: '/printedForm',
  component: Layout,
  name: 'printForm',
  redirect: '/printedForm/index',
  children: [
    {
      path: '/printedForm/index',
      component: () => import('@/views/printedForm/index'),
      name: 'printedForm',
      meta: { title: 'aaaa'}
    },
    // {
    //   path: '/printCenter/index',
    //   component: () => import('@/views/printCenter/index'),
    //   name: 'printCenter',
    //   meta: { title: 'printCenter'}
    // },
    {
      path: '/printCenter/printCenter',
      component: () => import('@/views/printCenter/printCenter'),
      name: 'printCenterList',
      meta: { title: i18n.t(`message.conclusions_history`)}
    }
  ]
}

export default printedForm